let DOMParser;

if (typeof window !== 'undefined' && window.DOMParser) {
  // Browser environment
  DOMParser = window.DOMParser;
} else {
  // Node.js environment - DOMParser is not available, handle it differently
  DOMParser = function() {
    throw new Error('DOMParser is not available in Node.js environment.');
  };
}

const removeCssFromACode = htmlString => {
  let doc;
  try {
    const parser = new DOMParser();
    doc = parser.parseFromString(htmlString, 'text/html');
  } catch (error) {
    // Handle the case where DOMParser is not available
    console.error('DOMParser is not available in this environment.');
    return ''; // or handle it as needed
  }

  // Remove all style attributes
  const elementsWithStyle = doc.querySelectorAll('[style]');
  elementsWithStyle.forEach(element => {
    element.removeAttribute('style');
  });

  // Remove all <style> tags
  const styleTags = doc.querySelectorAll('style');
  styleTags.forEach(styleTag => {
    styleTag.remove();
  });

  return doc.body.innerHTML;
};

export default removeCssFromACode;
